module.exports = __webpack_public_path__ + "img/pmg-shops.43abc3ac.png";